import { Box, Button, Grid, Typography } from "@mui/material";
import {
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedCheckboxRHF,
    EnhancedDropDownRHFWithLabel,
    LabelPosition,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { formatDateToShow } from "../../../../../common/Common";

interface IImportTimeSheetsInfoSetupFieldsPanel {
    payPeriodFrequnecyDDL: any;
    handleImportClick: (tag: string) => void;
    importDataPageName: string
}

export const ImportTimeSheetsInfoSetupFieldsPanel: FC<
    IImportTimeSheetsInfoSetupFieldsPanel
> = ({ payPeriodFrequnecyDDL, handleImportClick, importDataPageName }) => {

    const [selectedPayPeriod, setSelectedPayPeriod] = useState<any>(null);
    console.log("selectedPayPeriod", selectedPayPeriod);

    const onPayPeriodSelectionChangedHandler = (item: any) => {
        if (!item || !item.value) {
            setSelectedPayPeriod(null);
            return;
        }
        setSelectedPayPeriod(item);
    };
    return (
        <>
            <EnhancedDropDownRHFWithLabel
                selectName={"payrollScheduleId"}
                items={payPeriodFrequnecyDDL ?? []}
                label={"Pay Period"}
                testId={"pay-period-ddl"}
                onSelectionChangeHandler={onPayPeriodSelectionChangedHandler}
                showEmpty
            />
            {importDataPageName !== 'humanity' && <EnhancedDropDownRHFWithLabel
                selectName={"workFormat"}
                items={[
                    { label: "Hours Worked", value: 100 },
                    { label: "Time In and Time Out", value: 200 }]}
                label={"Import Time sheet data"}
                testId={"import-time-sheet-data"}
                selectedItem={100}
            />}
            {importDataPageName === 'humanity' &&
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "1rem",
                        justifyContent: "space-between"
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: ".875rem",
                            fontWeight: 600,
                            color: "#080808",
                        }}
                    >
                        Import Time sheet data
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: ".875rem",
                            color: "#080808",
                        }}
                    >
                        Hours Worked
                    </Typography>
                </Box>}
            {importDataPageName === 'humanity' && <EnhancedCheckboxRHF
                name="deductBreaks"
                checked={true}
                testId="deduct-breaks"
                // labelColumns={4}
                // fieldColumns={8}
                checkboxLabel="Deduct Breaks"
            />}
            {selectedPayPeriod && selectedPayPeriod.endDate !== null && selectedPayPeriod.endDate && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        flexWrap: "wrap",
                        marginBottom: "1rem"
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: ".875rem",
                            fontWeight: 600,
                            color: "#080808",
                        }}
                    >
                        Timesheet data available for import from
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: ".875rem",
                            color: "#080808",
                        }}
                    >
                        {formatDateToShow(selectedPayPeriod.startDate)} to {formatDateToShow(selectedPayPeriod.endDate)}
                    </Typography>
                </Box>
            )}
           {selectedPayPeriod && <EnhancedButtonPrimeReact
                label="Import Data"
                raised
                severity={EnhancedButtonPrimeReactSeverity.Secondary}
                // loading={isImporting}
                onClickHandler={() => handleImportClick("import_timesheets")}
            />}
            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{ marginTop: "2rem" }}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
                        {importDataPageName === 'humanity' ? "  Existing data will be overwritten." : "Existing data will be overwritten."}
                    </span><br />
                    <span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
                        {importDataPageName === 'humanity' ? " If employees' mapping is by Employee Name Employee Name must be same as in Humanity." : "Hours will be imported as regular hours."}
                    </span><br />
                    <span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
                        {importDataPageName === 'humanity' ? " If employees' mapping is by Custom ID Custom ID in employee setup must be same as ID in Humanity." : "If multiple rates are used within a pay period for an employee,"}
                    </span><br />
                    <span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
                        {importDataPageName === 'humanity' ? " Regular Hours will be imported as regular hours." : "gross amount will be calculated and populated in Gross field in Payroll page."}
                    </span><br />
                    <span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
                        {importDataPageName === 'humanity' ? " Overtime Hours will be imported as overtime hours." : " Timesheet will be imported for only those employees who are imported from When I Work."}
                    </span><br />
                    <span style={{ color: "#c0c0c0", fontSize: ".775rem" }}>
                        {importDataPageName === 'humanity' ? "Only approved timesheets will be imported." : " Timesheet will be imported for only those employees who are imported from When I Work."}
                    </span>
                </Grid>
            </Grid>
        </>
    );
};